export default __webpack_public_path__ + "static/media/Benjamin_Beggs.0d908005.jpg";